<template>
  <v-menu
    left
    :close-on-content-click="false"
    v-model="menuOpened"
    max-width="550"
    min-width="400"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click.stop.prevent="">
        <v-icon>
          mdi-filter
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row>
          <v-col cols="12">
            <px-autocomplete-catalogo
              required
              v-model="catalogoLocal"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="apply">
          Aplicar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      catalogoLocal: null,
      menuOpened: false,
    };
  },
  computed: {
    catalogo: {
      get() {
        return this.$store.getters['listagemOfertas/catalogo'];
      },
      set(catalogo) {
        this.$store.dispatch('listagemOfertas/catalogo', catalogo);
      },
    },
  },
  methods: {
    close() {
      this.menuOpened = false;
    },
    apply() {
      this.catalogo = { ...this.catalogoLocal };
      this.$emit('change');
      this.close();
    },
    setupInitialState() {
      if (this.catalogo) {
        this.catalogoLocal = this.catalogo;
      } else {
        this.catalogoLocal = null;
      }
    },
  },
  watch: {
    menuOpened(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (!newValue) {
        return;
      }
      this.setupInitialState();
    },
  },
};
</script>
